import { render, staticRenderFns } from "./app.vue?vue&type=template&id=f6af6a70&scoped=true"
import script from "./app.js?vue&type=script&lang=js&external"
export * from "./app.js?vue&type=script&lang=js&external"
import style0 from "./app.scss?vue&type=style&index=0&id=f6af6a70&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6af6a70",
  null
  
)

export default component.exports